import { AfterViewInit, Component, Input, Output, EventEmitter, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Accordion, AccordionPanel, AccordionHeader, AccordionContent } from 'primeng/accordion';
import { Tooltip } from 'primeng/tooltip';
import { MarkdownModule } from 'ngx-markdown';
import { ClipboardService } from '@brighthub/utils';
import { Message } from '../../models/copilot.models';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'lib-chat-message-trace',
  imports: [
    CommonModule,
    MarkdownModule,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    Tooltip,
    ButtonDirective,
  ],
  templateUrl: './chat-message-trace.component.html',
  styleUrls: ['./chat-message-trace.component.scss'],
})
export class ChatMessageTraceComponent implements AfterViewInit {
  private _clipboard = inject(ClipboardService);

  /** Removed shortly after init so CSS only hides content on first paint (avoids flash; doesn't block close animation). */
  readonly initialClosed = signal(true);

  @Input() message!: Message;
  @Input() conversationId!: string;
  @Input() messageId!: string;
  @Output() scrollDown = new EventEmitter<string>();

  copyToClipboard(text: string): void {
    this._clipboard.copy(text);
  }

  scrollToBottom(behavior: 'smooth' | 'auto' = 'smooth'): void {
    this.scrollDown.emit(behavior);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.initialClosed.set(false), 250);
  }
}
